import { render, staticRenderFns } from "./CommandItem.vue?vue&type=template&id=1233be39"
import script from "./CommandItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommandItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports